module.exports = __webpack_public_path__ + "static/media/ss.7cda8cb5.svg";